import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export type ReportStatus = "generating" | "ready" | "failed";

export interface ReportRecord {
  id: number;
  project_id: number;
  project_code: string;
  project_name: string;
  from_date: string;
  to_date: string;
  status: ReportStatus;
  filename: string | null;
  file_size: number | null;
  error_message: string | null;
  created_at: string;
  updated_at: string;
}

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  tagTypes: ["Report"],
  endpoints: (builder) => ({
    listReports: builder.query<ReportRecord[], number | undefined>({
      query: (projectId) =>
        projectId != null
          ? `/reports/list?projectId=${projectId}`
          : `/reports/list`,
      providesTags: ["Report"],
    }),

    generateReport: builder.mutation<
      ReportRecord,
      { projectId: number; from: string; to: string }
    >({
      query: ({ projectId, from, to }) => ({
        url: `/reports/generate`,
        method: "POST",
        body: { projectId, from, to },
      }),
      invalidatesTags: ["Report"],
    }),

    downloadStoredReport: builder.query<Blob, number>({
      query: (id) => ({
        url: `/reports/${id}/download`,
        responseHandler: (response) => response.blob(),
        cache: "no-cache",
      }),
    }),
  }),
});

export const {
  useListReportsQuery,
  useGenerateReportMutation,
  useLazyDownloadStoredReportQuery,
} = reportsApi;
